module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../src/~/amazon-cognito-identity-js/~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 721
// module chunks = 0